import React from 'react';

import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import { clearSearchItems, setSearchItems } from '../../redux/features/searchSlice';
import { setIsFilterOnSearch, updateSelectedItemsList } from '../../redux/features/mapDataSlice';
import { selectDropdownStyles } from '../../app-constants';


const orderOptions = (values) => values;

const SearchableDropdown = () => {
    const dispatch = useDispatch();
    const { searchItems } = useSelector((state) => state.search);
    const { filteredDataList } = useSelector((state) => state.mapData);

    const onChange = (
        newValue,
        actionMeta
    ) => {
        switch (actionMeta.action) {
            case 'remove-value':
            case 'pop-value':
                if (actionMeta.removedValue.isFixed) {
                    return;
                }
                break;
            case 'clear':
                newValue = filteredDataList.filter((v) => v.isFixed);
                break;
            default:
                break;
        }

        const selectedStall = orderOptions(newValue);
        let selectedStallName = [];
        let isFilterOnSearch = false;
        console.log(selectedStall);
        if (selectedStall && selectedStall.name) {
            dispatch(setSearchItems({ ...selectedStall }));
            isFilterOnSearch = true;
            selectedStallName = [selectedStall.name];
        } else {
            dispatch(clearSearchItems());
        }
        dispatch(setIsFilterOnSearch(isFilterOnSearch));
        setTimeout(() => {
            dispatch(updateSelectedItemsList(selectedStallName));
        }, 1);

    };

    return (
        <Select
            value={searchItems}
            styles={selectDropdownStyles}
            isClearable={searchItems}
            name="searchShopsOnDirectorySearch"
            className="basic-multi-select"
            classNamePrefix="select"
            onChange={onChange}
            id="searchShopsOnDirectorySearch"
            options={filteredDataList}
            placeholder="Search Shops"
        />
    );
};

export default SearchableDropdown;